var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1269.000000pt",
    height: "900.000000pt",
    viewBox: "0 0 1269.000000 900.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,900.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 8971 c-102 -33 -182 -89 -249 -174 l-39 -49 0 -255 0 -254 29 -42 c61 -87 154 -155 260 -187 62 -20 128 -20 6051 -20 5945 0 5988 0 6052 20 109 33 207 108 272 205 l26 40 0 234 0 234 -31 49 c-61 94 -161 167 -278 202 -50 15 -564 16 -6045 15 -5769 0 -5993 -1 -6048 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 4971 c-102 -33 -182 -89 -249 -174 l-39 -49 0 -255 0 -254 29 -42 c61 -87 154 -155 260 -187 62 -20 128 -20 6051 -20 5945 0 5988 0 6052 20 109 33 207 108 272 205 l26 40 0 234 0 234 -31 49 c-61 94 -161 167 -278 202 -50 15 -564 16 -6045 15 -5769 0 -5993 -1 -6048 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 971 c-102 -33 -182 -89 -249 -174 l-39 -49 0 -255 0 -254 30 -44 c42 -61 113 -120 189 -158 l66 -32 6055 0 6055 0 67 33 c79 39 154 104 197 170 l31 49 0 233 0 233 -31 49 c-61 94 -161 167 -278 202 -50 15 -564 16 -6045 15 -5769 0 -5993 -1 -6048 -18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMenu);
export default __webpack_public_path__ + "static/media/header_menu.52fac7c814835b2f4384615094f4ed1f.svg";
export { ForwardRef as ReactComponent };